if (!window.evNavigationReady) {
  window.evNavigationReady = true;
  document.addEventListener('change', event => {
    if (event.target.matches('#EvNavLanguageCode, #EvNavCountryCode')) {
      const returnTo = event.target.form.querySelector('[name="return_to"]');
      if (returnTo) returnTo.value = window.location.pathname + window.location.search + window.location.hash;
      event.target.form.requestSubmit();
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const opened = event.target.closest('.ev-nav-header details[open]');
    if (!opened) return;
    opened.open = false;
    opened.querySelector(':scope > summary')?.focus();
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.ev-nav-desktop .ev-nav-dropdown[open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.open = false;
    });
    const link = event.target.closest('.ev-nav-header a');
    if (link) link.closest('.ev-nav-header').querySelectorAll('details[open]').forEach(menu => { menu.open = false; });
  });
}

document.addEventListener('keydown',event=>{
 if(event.key!=='Tab'||!window.matchMedia('(max-width:989px)').matches)return;
 const menu=document.querySelector('.ev-nav-mobile[open]');if(!menu)return;
 const targets=[...menu.querySelectorAll('summary,a[href],button:not([disabled]),select,input')].filter(item=>item.getClientRects().length);
 const first=targets[0],last=targets[targets.length-1];if(!first)return;
 if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
 else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
});
